<template>

  <div>
     <KTCodePreview v-bind:title="printPreviewTitle"
      > <template v-slot:toolbar
        > <b-button
          variant="outline-success"
          size="sm"
          class="font-weight-bolder mr-2"
          style="width: max-content"
          :disabled="!stockSlipId || isExportingExcel"
          @click="exportExcel"
          > <b-spinner
            v-if="isExportingExcel"
            small
            class="mr-1"
          ></b-spinner
          > <i
            v-else
            style="font-size: 1rem"
            class="far fa-file-excel"
          ></i
          > {{ isExportingExcel ? 'Đang xuất...' : 'Xuất Excel' }} </b-button
        > <b-button
          variant="primary"
          size="sm"
          @click="printData"
          style="width: max-content"
          > <i class="fas fa-print"></i> In phiếu </b-button
        > </template
      > <template v-slot:preview
        >
        <div id="printMe">
           <!-- Mẫu 02/TNDN — phiếu nhập kho HKD -->
          <div
            v-if="isImportHkd"
            class="tndn-print"
          >

            <div class="tndn-meta text-right mb-2">

              <div class="font-weight-bold">Mẫu số: 02/TNDN</div>

              <div> (Ban hành kèm theo Thông tư số 20/2026/TT-BTC của Bộ trưởng Bộ Tài chính) </div>

            </div>

            <h5 class="text-center font-weight-bold mb-1">
               BẢNG KÊ THU MUA HÀNG HÓA, DỊCH VỤ KHÔNG CÓ HÓA ĐƠN
            </h5>

            <p class="text-center mb-3">
               (Ngày {{ slipDateParts.day }} tháng {{ slipDateParts.month }} năm {{
                slipDateParts.year
              }})
            </p>

            <div class="tndn-company mb-3">

              <p class="mb-1">
                 <span class="font-weight-bold">Tên doanh nghiệp:</span> {{ tndnEnterprise.name }}
              </p>

              <p class="mb-1">
                 <span class="font-weight-bold">Mã số thuế:</span> {{ tndnEnterprise.tax }}
              </p>

              <p class="mb-1">
                 <span class="font-weight-bold">Địa chỉ:</span> {{ tndnEnterprise.address }}
              </p>

              <p
                class="mb-1"
                v-if="tndnEnterprise.phone"
              >
                 <span class="font-weight-bold">Số điện thoại:</span> {{ tndnEnterprise.phone }}
              </p>

              <p class="mb-0">
                 <span class="font-weight-bold">Địa chỉ nơi tổ chức thu mua:</span> {{
                  tndnEnterprise.purchaseLocation || '—'
                }}
              </p>

            </div>

            <table class="table table-bordered tndn-table mb-3">
              <colgroup>
                <col style="width: 7%" />
                <col style="width: 9%" />
                <col style="width: 9%" />
                <col style="width: 7%" />
                <col style="width: 8%" />
                <col style="width: 16%" />
                <col style="width: 6%" />
                <col style="width: 9%" />
                <col style="width: 9%" />
                <col style="width: 20%" />
              </colgroup>

              <thead>

                <tr>

                  <th
                    rowspan="2"
                    class="text-center align-middle tndn-th"
                  >
                     Ngày tháng năm<br />mua hàng
                  </th>

                  <th
                    colspan="4"
                    class="text-center tndn-th"
                  >
                     Người bán
                  </th>

                  <th
                    colspan="4"
                    class="text-center tndn-th"
                  >
                     Hàng hóa, dịch vụ mua vào
                  </th>

                  <th
                    rowspan="2"
                    class="text-center align-middle tndn-th tndn-th-notes"
                  >
                     Ghi chú
                  </th>

                </tr>

                <tr>

                  <th class="text-center tndn-th">Tên người bán</th>

                  <th class="text-center tndn-th">Địa chỉ</th>

                  <th class="text-center tndn-th">Số căn cước</th>

                  <th class="text-center tndn-th"> Số điện thoại<br />(nếu có) </th>

                  <th class="text-center tndn-th"> Tên hàng hóa,<br />dịch vụ </th>

                  <th class="text-center tndn-th"> Số lượng,<br />trọng lượng </th>

                  <th class="text-center tndn-th">Đơn giá</th>

                  <th class="text-center tndn-th">Tổng giá thanh toán</th>

                </tr>

                <tr class="tndn-col-idx tndn-th text-center">

                  <th>1</th>

                  <th>2</th>

                  <th>3</th>

                  <th>4</th>

                  <th>5</th>

                  <th>6</th>

                  <th>7</th>

                  <th>8</th>

                  <th>9</th>

                  <th class="tndn-th-notes">10</th>

                </tr>

              </thead>

              <tbody>

                <tr
                  v-for="row in listItem"
                  :key="row.count"
                >

                  <td class="text-center tndn-td"> {{ formatPurchaseDate(row) }} </td>

                  <td class="tndn-td">{{ sellerInfo.name }}</td>

                  <td class="tndn-td">{{ sellerInfo.address || '—' }}</td>

                  <td class="tndn-td">{{ sellerInfo.identity || '—' }}</td>

                  <td class="tndn-td">{{ sellerInfo.phone || '—' }}</td>

                  <td class="tndn-td">{{ row.productName }}</td>

                  <td class="text-right tndn-td">{{ formatMoney(row.quantity) }}</td>

                  <td class="text-right tndn-td">{{ formatMoney(row.unitPrice) }}</td>

                  <td class="text-right tndn-td">{{ formatMoney(row.totalAmount) }}</td>

                  <td class="tndn-td tndn-td-notes">{{ formatTndnNotes(row) }}</td>

                </tr>

              </tbody>

            </table>

            <div class="tndn-footer mb-4">

              <p class="mb-1">
                 <span class="font-weight-bold">Tổng giá trị hàng hóa, dịch vụ mua vào:</span> {{
                  formatMoney(sumTotalAmount)
                }}
              </p>

              <p class="mb-0">
                 <span class="font-weight-bold">(Số tiền bằng chữ:</span> {{
                  stockSlip.textAmount || '—'
                }}<span class="font-weight-bold">).</span>
              </p>

            </div>

            <div class="text-right tndn-date-line mb-3">
               Ngày {{ slipDateParts.day }} tháng {{ slipDateParts.month }} năm {{
                slipDateParts.year
              }}
            </div>
             <b-row class="tndn-signatures"
              > <b-col
                md="6"
                class="text-center"
                >
                <p class="font-weight-bold mb-1">Người lập bảng kê</p>

                <p class="mb-0">(Ký, ghi rõ họ tên)</p>
                 </b-col
              > <b-col
                md="6"
                class="text-center"
                >
                <p class="font-weight-bold mb-1">
                   Người đại diện hoặc người được ủy quyền của doanh nghiệp
                </p>

                <p class="mb-0">(Ký tên, đóng dấu)</p>
                 </b-col
              > </b-row
            >
          </div>
           <template v-else
            > <b-row
              style="display: block"
              class="mb-10"
              >
              <div class="text-center">

                <h5>{{ stockSlip.typeName }}</h5>

                <p>{{ stockSlip.modeName }}</p>

              </div>
               </b-row
            > <b-row
              > <b-col md="8"
                >
                <p> <span class="custom-lable-text">Mã phiếu</span> : {{ stockSlip.code }} </p>
                 </b-col
              > <b-col md="4"
                >
                <p> <span class="custom-lable-text">Kho</span> : {{ stockSlip.storeName }} </p>
                 </b-col
              > </b-row
            > <b-row
              > <b-col md="8"
                >
                <p> <span class="custom-lable-text">Ngày</span> : {{ stockSlip.createdAt }} </p>
                 </b-col
              > <b-col md="4"
                >
                <p>
                   <span class="custom-lable-text">Địa chỉ</span> : {{ stockSlip.storeAddress }}
                </p>
                 </b-col
              > </b-row
            > <b-row
              > <b-col md="8"
                >
                <p>
                   <span class="custom-lable-text">{{ stockSlip.providerLableName }}</span
                  > : {{ stockSlip.providerName }}
                </p>
                 </b-col
              > <b-col md="4"
                >
                <p> <span class="custom-lable-text">Người lập</span> : {{ stockSlip.createBy }} </p>
                 </b-col
              > </b-row
            > <b-row
              > <b-col md="8"
                >
                <p>
                   <span class="custom-lable-text">Điện thoại</span> : {{
                    stockSlip.providerPhoneNo
                  }}
                </p>
                 </b-col
              > <b-col md="4"
                >
                <p v-if="stockSlip.billId">
                   <span class="custom-lable-text">Từ hóa đơn</span> : {{ stockSlip.billId }}
                </p>
                 </b-col
              > </b-row
            > <b-row
              > <b-col md="8"
                >
                <p>
                   <span class="custom-lable-text">Ghi chú</span> : {{ stockSlip.description }}
                </p>
                 </b-col
              > </b-row
            > <b-table
              :items="listItem"
              :fields="fields"
              :bordered="true"
              :hover="true"
              > <template slot="bottom-row"
                >
                <td
                  v-bind:colspan="5"
                  class="text-right font-weight-bolder"
                  style="font-weight: 600; color: #181c32"
                >
                   <span>Tổng:</span>
                </td>

                <td class="text-right font-weight-bolder">
                   <span>{{ formatMoney(sumQuantity) }}</span
                  >
                </td>
                 </template
              > </b-table
            > <b-row
              > <b-col class="text-center"
                >
                <p class="mb-0"> <span class="custom-lable-text">Người lập phiếu</span> </p>

                <p>(Ký, họ tên)</p>
                 </b-col
              > <b-col
                >
                <p class="mb-0"> <span class="custom-lable-text">Người giao hàng</span> </p>

                <p>(Ký, họ tên)</p>
                 </b-col
              > <b-col
                >
                <p class="mb-0"> <span class="custom-lable-text">Người nhận hàng</span> </p>

                <p>(Ký, họ tên)</p>
                 </b-col
              > <b-col
                ><p class="mb-0"> <span class="custom-lable-text">Thủ kho</span> </p>

                <p>(Ký, họ tên)</p>
                 </b-col
              > <b-col
                ><p class="mb-0"> <span class="custom-lable-text">Giám đốc</span> </p>

                <p>(Ký, họ tên)</p>
                 </b-col
              > </b-row
            > </template
          >
        </div>
         </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import ApiService from '@/core/services/api.service'
  import _ from 'lodash'
  import moment from 'moment'
  import { convertNumberToText, printData } from '@/utils/common'
  import fileDownload from '@/utils/file-download'
  import { STOCK_SLIP_TYPE } from '@/utils/enum'
  import { SUPPLIER_INFO } from '@/utils/constants'

  export default {
    data() {
      return {
        fields: [
          {
            key: 'count',
            label: 'STT',
            thStyle: {
              textAlign: 'center',
              fontWeight: 600,
              color: '#181c32',
              width: '4%',
            },
            tdClass: 'text-center',
          },
          {
            key: 'barCode',
            label: 'Mã vạch',
            thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          },
          {
            key: 'productCode',
            label: 'Mã sản phẩm',
            thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          },
          {
            key: 'productName',
            label: 'Tên sản phẩm',
            thStyle: { fontWeight: 600, color: '#181c32', width: '17%' },
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          },
          {
            key: 'quantity',
            label: 'SL',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return this.formatMoney(value)
            },
          },
        ],
        listItem: [],
        stockSlip: {
          code: '',
          type: null,
          typeName: '',
          modeName: '',
          storeName: '',
          createdAt: '',
          storeAddress: '',
          providerName: '',
          providerPhoneNo: '',
          providerLableName: '',
          createBy: '',
          description: '',
          textAmount: '',
          billId: '',
        },
        sumQuantity: 0,
        sumUnitPrice: 0,
        sumDiscountAmount: 0,
        sumTotalAmount: 0,
      }
    },
    components: {
      KTCodePreview,
    },
    computed: {
      stockSlipId() {
        return this.$route.query.id
      },
      isImportHkd() {
        return Number(this.stockSlip.type) === STOCK_SLIP_TYPE.IMPORT_HKD
      },
      printPreviewTitle() {
        return this.isImportHkd ? 'In bảng kê thu mua (02/TNDN — HKD)' : 'In phiếu'
      },
      tndnEnterprise() {
        const s = this.stockSlip
        return {
          name: s.companyName || SUPPLIER_INFO.companyName,
          tax: s.companyTaxCode || s.taxCode || SUPPLIER_INFO.taxCode,
          address: s.companyAddress || SUPPLIER_INFO.address,
          phone: s.companyPhone || s.phoneNo || '',
          purchaseLocation: s.purchaseLocationAddress || s.purchaseAddress || s.storeAddress || '',
        }
      },
      sellerInfo() {
        const s = this.stockSlip
        return {
          name: s.providerName || '',
          address: s.providerAddress || s.providerFullAddress || '',
          identity:
            s.providerIdentityCard ||
            s.providerCitizenId ||
            s.providerIdNumber ||
            s.identityNumber ||
            '',
          phone: s.providerPhoneNo || '',
        }
      },
      slipDateParts() {
        const raw = this.stockSlip.createdAt
        const m = moment(raw, ['DD/MM/YYYY HH:mm', 'DD/MM/YYYY', moment.ISO_8601], true)
        if (!m.isValid()) {
          return { day: '....', month: '....', year: '....' }
        }
        return {
          day: m.format('DD'),
          month: m.format('MM'),
          year: m.format('YYYY'),
        }
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: 'In phiếu kho' }])
      this.getStockSlipById()
    },
    methods: {
      printData() {
        printData()
      },
      async exportExcel() {
        const stockSlipId = this.stockSlipId
        if (!stockSlipId || this.isExportingExcel) return

        this.isExportingExcel = true
        try {
          const response = await ApiService.get(
            `v1/stock-slips/${stockSlipId}/print/export-excel`,
            { responseType: 'blob' },
          )
          let fileName
          try {
            fileName = fileDownload.getFileName(response)
          } catch {
            fileName = `in-phieu-kho-${this.stockSlip.code || stockSlipId}.xlsx`
          }
          fileDownload.createFile(response.data, fileName)
        } catch {
          this.$bvToast.toast('Xuất Excel thất bại, vui lòng thử lại.', {
            title: 'Lỗi',
            variant: 'danger',
            solid: true,
          })
        } finally {
          this.isExportingExcel = false
        }
      },
      formatMoney: function (number) {
        if (!number) return 0
        return new Intl.NumberFormat('vn-VN').format(number)
      },
      formatPurchaseDate(row) {
        const raw =
          row.purchaseDate || row.stockSlipDate || row.createdAt || this.stockSlip.createdAt
        const m = moment(raw, ['DD/MM/YYYY HH:mm', 'DD/MM/YYYY', moment.ISO_8601], true)
        return m.isValid() ? m.format('DD/MM/YYYY') : raw || '—'
      },
      collectImeisFromRow(row) {
        const out = []
        const add = (val) => {
          if (val == null || val === '') return
          String(val)
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
            .forEach((s) => out.push(s))
        }
        if (Array.isArray(row.imeis)) {
          row.imeis.forEach((item) => {
            if (typeof item === 'string') add(item)
            else if (item) add(item.imeiCode || item.imeiNo || item.code)
          })
        }
        add(row.productImei)
        add(row.IMEI)
        add(row.imeiCode)
        return [...new Set(out)]
      },
      formatTndnNotes(row) {
        const base = (row.notes || row.description || '').trim()
        const imeiStr = this.collectImeisFromRow(row).join(', ')
        if (!base && !imeiStr) return '—'
        if (!base) return imeiStr
        if (!imeiStr) return base
        return `${base}. ${imeiStr}`
      },
      getStockSlipById: async function () {
        const stockSlipId = this.$route.query.id
        await ApiService.get(`v1/stock-slips/${stockSlipId}/print`).then((data) => {
          const responseData = data.data.data
          this.listItem = (responseData.details || []).map((element, index) => ({
            count: index + 1,
            ...element,
          }))
          this.stockSlip = responseData
          this.stockSlip.type =
            responseData.type === STOCK_SLIP_TYPE.IMPORT_PROVIDER && !responseData.hasVat
              ? STOCK_SLIP_TYPE.IMPORT_HKD
              : responseData.type
          this.sumQuantity = _.sumBy(this.listItem, 'quantity')
          this.sumUnitPrice = _.sumBy(this.listItem, 'unitPrice')
          this.sumDiscountAmount = _.sumBy(this.listItem, 'discountAmount')
          this.sumTotalAmount = _.sumBy(this.listItem, 'totalAmount')
          this.stockSlip.textAmount = convertNumberToText(this.sumTotalAmount)
        })
        printData()
      },
    },
  }
</script>

<style scoped>
  .custom-lable-text {
  font-size: 13px;
  font-weight: 500 !important;
}

.tndn-print {
  font-size: 14px;
  color: #181c32;
}

.tndn-print h5 {
  font-size: 14px;
  font-weight: 700;
}

.tndn-meta,
.tndn-company,
.tndn-footer,
.tndn-date-line,
.tndn-signatures {
  font-size: 14px;
}

.tndn-table {
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  table-layout: fixed;
  border-collapse: collapse;
}

.tndn-table th,
.tndn-table td {
  padding: 0.5rem 0.35rem;
  vertical-align: middle;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.tndn-td-notes {
  vertical-align: top;
  word-break: break-all;
  overflow-wrap: anywhere;
  hyphens: none;
}

.tndn-th-notes {
  vertical-align: middle;
  overflow-wrap: break-word;
}

.tndn-th {
  font-size: 13px;
  font-weight: 600;
}

.tndn-td {
  font-size: 14px;
}

.tndn-col-idx th {
  padding: 0.25rem;
  font-weight: 600;
}

.tndn-signatures {
  margin-top: 2rem;
}
</style>

<style>
  .table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}

/* In mẫu TNDN: full width, cột ghi chú/IMEI không làm vỡ khung */
@page {
  size: A4 portrait;
  margin: 10mm;
}

@media print {
  #printMe .tndn-print {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  #printMe .tndn-table {
    width: 100% !important;
    max-width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    page-break-inside: auto;
  }

  #printMe .tndn-table th,
  #printMe .tndn-table td {
    padding: 5px 4px !important;
    box-sizing: border-box;
  }

  #printMe .tndn-signatures.row {
    display: flex !important;
    flex-wrap: nowrap !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  #printMe .tndn-signatures [class*='col-'] {
    flex: 0 0 50% !important;
    max-width: 50% !important;
    width: 50% !important;
  }
}
</style>

